'use client';

import Link from '@/components/Link';
import {BookOpen} from 'lucide-react';
import {documentationContent} from '@/lib/landing/content';
import {cardHoverClass, FadeIn, sectionBorderLight, sectionPadding, SectionContainer} from './shared';

export function DocumentationSection() {
  return (
    <section id={documentationContent.id} aria-labelledby="docs-heading" className={`${sectionPadding} bg-kobra-bg ${sectionBorderLight} relative`}>
      <SectionContainer>
        <FadeIn>
          <article className={`max-w-4xl mx-auto bg-kobra-bg border border-kobra-border rounded-3xl p-8 md:p-12 text-center hover:border-kobra-accent/40 ${cardHoverClass}`}>
            <BookOpen className="w-12 h-12 text-kobra-accent mx-auto mb-6" aria-hidden="true" />
            <h2 id="docs-heading" className="text-3xl font-bold text-kobra-text-dark mb-4">
              {documentationContent.title}
            </h2>
            <p className="text-kobra-text-muted text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
              {documentationContent.description}
            </p>
            <ul className="flex flex-wrap justify-center gap-2 mb-8">
              {documentationContent.topics.map((topic) => (
                <li key={topic}>
                  <span className="bg-white border border-kobra-border text-kobra-text-muted px-3.5 py-1.5 rounded-full text-sm font-medium">
                    {topic}
                  </span>
                </li>
              ))}
            </ul>
            <Link
              href="#docs"
              className="inline-flex bg-kobra-dark hover:bg-kobra-navy text-white px-8 py-3.5 rounded-full font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kobra-accent focus-visible:ring-offset-2"
            >
              Explorar la documentación
            </Link>
          </article>
        </FadeIn>
      </SectionContainer>
    </section>
  );
}
